import { createImageUrlBuilder } from '@sanity/image-url'

function getBuilder() {
	const projectId = typeof ENV !== 'undefined' ? ENV.SANITY_PROJECT_ID : ''
	const dataset = typeof ENV !== 'undefined' ? ENV.SANITY_DATASET : 'production'
	return createImageUrlBuilder({ projectId: projectId ?? '', dataset: dataset ?? 'production' })
}

type SanityImageSource = {
	asset?: { _ref?: string; _type?: string } | null
	hotspot?: { x?: number; y?: number } | null
	crop?: { top?: number; bottom?: number; left?: number; right?: number } | null
	[key: string]: unknown
}

export function urlFor(source: SanityImageSource | null | undefined) {
	if (!source?.asset?._ref) return null
	return getBuilder().image(source)
}

export function getImageUrl(
	source: SanityImageSource | null | undefined,
	options?: { width?: number; height?: number; quality?: number },
) {
	const img = urlFor(source)
	if (!img) return null

	let result = img.auto('format')

	if (options?.width) result = result.width(options.width)
	if (options?.height) result = result.height(options.height)
	if (options?.quality) result = result.quality(options.quality)

	return result.url()
}
